// Breakpoint values (px)
export const bp = {
  sm: 480,
  md: 768,
  lg: 1024,
} as const;

// Mobile-first min-width queries
// lt* = max-width (less-than) queries for progressive disclosure
export const mq = {
  sm:   `@media (min-width: ${bp.sm}px)`,
  md:   `@media (min-width: ${bp.md}px)`,
  lg:   `@media (min-width: ${bp.lg}px)`,
  ltSm: `@media (max-width: ${bp.sm - 1}px)`,
  ltMd: `@media (max-width: ${bp.md - 1}px)`,
  ltLg: `@media (max-width: ${bp.lg - 1}px)`,
} as const;
